import { C__CardPerson } from './c--card-person/C__CardPerson';
export const Components = {
    directives: {},
    modules: {
        C__CardPerson
    }
};
